import { render, staticRenderFns } from "./AppPunchInOutLayout.vue?vue&type=template&id=7a663b6e&"
import script from "./AppPunchInOutLayout.vue?vue&type=script&lang=ts&"
export * from "./AppPunchInOutLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports